import {enableProdMode} from '@angular/core';
import {environment} from './environments/environment';
import {initializeTranslations} from './app/core/i18n/app-locale';
import {bootstrapApplication} from '@angular/platform-browser';

if (environment.production) {
    enableProdMode();
}

initializeTranslations().then(async () => {
    const [{AppComponent}, {appConfig}] = await Promise.all([
        import('./app/app.component'),
        import('./app/app.config'),
        import('./app/shoelace'),
    ]);
    return bootstrapApplication(AppComponent, appConfig);
}).catch(error => console.error(error));
